import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ThemeSelector from './ThemeSelector';
import './Header.css';

interface HeaderProps {
  onNewTask?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onNewTask }) => {
  const { organization, logout, canUseAI } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleSettingsClick = () => {
    navigate('/app/settings');
  };

  const handleAIAssistantClick = () => {
    navigate('/app/ai-assistant');
  };

  const handleLogoutClick = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
    }
  };

  const isOnApp = location.pathname === '/app';
  const isOnSettings = location.pathname === '/app/settings';
  const isOnAIAssistant = location.pathname === '/app/ai-assistant';
  const hasAIAccess = canUseAI();

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="logo">
            <span className="logo-main">todo</span>
            <span className="logo-sub">bananowe.it</span>
          </h1>
          {organization && (
            <div className="organization-name">{organization.name}</div>
          )}
        </div>

        <div className="header-right">
          {onNewTask && (
            <button className={`new-task-btn ${isOnApp ? 'active' : ''}`} onClick={onNewTask}>
              <span>+</span>
              <span>new task</span>
            </button>
          )}
          
          <button className={`settings-btn ${isOnSettings ? 'active' : ''}`} onClick={handleSettingsClick}>
            <span>⚙</span>
            <span>settings</span>
          </button>

          {hasAIAccess && (
            <button className={`ai-assistant-btn ${isOnAIAssistant ? 'active' : ''}`} onClick={handleAIAssistantClick}>
              <span>🤖</span>
              <span>AI Assistant</span>
            </button>
          )}

          <button className="logout-btn" onClick={handleLogoutClick}>
            <span>↗</span>
            <span>logout</span>
          </button>

          <ThemeSelector />
        </div>
      </div>
    </header>
  );
};

export default Header; 